import React from "react";
import bg_img from "../../assets/analytics/bg_img.jpg";
import sales from "../../assets/analytics/sales.png";
import finance from "../../assets/analytics/report.png";
import operations from "../../assets/analytics/operational-system.png";
import customer from "../../assets/analytics/customer-review.png";
import employee from "../../assets/analytics/staff.png";
import healthcare from "../../assets/analytics/healthcare.png";

const Analytics_services = () => {
  return (
    <div id="solutions">
      <div>
        <p className="text-center font-notosans text-2xl sm:text-4xl font-bold text-[#333e49]">
          Advanced Analytics Drives Increased Effectiveness in every
          Functions...
        </p>

        <div className="px-2 sm:px-10 mt-10">
          <div className="flex justify-between font-notosans">
            <span className="flex flex-col justify-center items-center gap-4 w-1/3 text-center text-sm sm:text-base">
              <img src={sales} className="w-12 sm:w-16" />
              Sales and Revenue Analysis
            </span>
            <span className="flex flex-col justify-center items-center gap-4 w-1/3 text-center text-sm sm:text-base">
              <img src={finance} className="w-12 sm:w-16" />
              Financial Performance Monitoring
            </span>
            <span className="flex flex-col justify-center items-center gap-4 w-1/3 text-center text-sm sm:text-base">
              <img src={operations} className="w-12 sm:w-16" />
              Operational Efficiency and Supply Chain Management
            </span>
          </div>

          <div className="flex justify-between font-notosans">
            <span className="flex flex-col justify-center items-center gap-4 w-1/3 text-center text-sm sm:text-base">
              <img src={customer} className="w-12 sm:w-16" />
              Customer Insights and Retention
            </span>
            <span className="flex flex-col justify-center items-center gap-4 w-1/3 text-center text-sm sm:text-base">
              <img src={employee} className="w-12 sm:w-16" />
              Employee Performance and HR Analytics
            </span>
            <span className="flex flex-col justify-center items-center gap-4 w-1/3 text-center text-sm sm:text-base">
              <img src={healthcare} className="w-12 sm:w-16" />
              Healthcare Analytics for Patient Outcomes
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics_services;
